import { isHttpError } from "@crialume/sdk";

/**
 * Mensagem apresentável ao usuário para qualquer erro.
 * Mensagens do backend são usadas; textos técnicos (rede, timeout,
 * "HTTP 500") caem no `fallback` da tela.
 */
export function getErrorMessage(error: unknown, fallback: string): string {
  if (isHttpError(error)) {
    if (error.isNetworkError) return "Não foi possível conectar ao servidor. Tente novamente.";
    if (error.status >= 500 || error.message.startsWith("HTTP ")) return fallback;
    return error.message;
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}

/**
 * Código de negócio do ProblemDetails (`{ "code": "auth.invalid_credentials" }`),
 * para a tela reagir a um caso específico sem comparar textos.
 */
export function getErrorCode(error: unknown): string | undefined {
  if (!isHttpError(error) || !error.body || typeof error.body !== "object") return undefined;
  const code = (error.body as Record<string, unknown>)["code"];
  return typeof code === "string" ? code : undefined;
}

/**
 * Erros de validação por campo (`ValidationProblemDetails.errors`), com a chave
 * em camelCase ("AdminEmail" → "adminEmail") para casar com os nomes do formulário.
 */
export function getFieldErrors(error: unknown): Record<string, string> {
  if (!isHttpError(error) || !error.body || typeof error.body !== "object") return {};
  const errors = (error.body as Record<string, unknown>)["errors"];
  if (!errors || typeof errors !== "object" || Array.isArray(errors)) return {};
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(errors)) {
    const message = Array.isArray(value) ? value.find((v) => typeof v === "string") : value;
    if (typeof message === "string" && key) {
      result[key.charAt(0).toLowerCase() + key.slice(1)] = message;
    }
  }
  return result;
}
